import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { isObject } from '../utils/typeChecks';

export class PortfolioQuery extends BaseQuery {
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { code, key } = this.options;
		const instance = this.getPortfolioFromContext(executionOptions);
		if (isObject(instance) && code) {
			if (code === 'extended') {
				if (isObject(instance.extended)) {
					return instance.extended[key] as T;
				}
			}
			else {
				return instance[code];
			}
		}
		return undefined;
	}
}